import { useState } from 'react'
import { MoreVert } from '@mui/icons-material'
import { Link, Menu } from '@mui/material'

interface Props {
  showMoreNavLink: boolean
}

export const MoreMenu = ({ showMoreNavLink }: Props) => {
  const [menuAnchor, setMenuAnchor] = useState(null)

  function handleClick(event) {
    setMenuAnchor(event.currentTarget)
  }

  function handleClose() {
    setMenuAnchor(null)
  }

  return (
    <>
      {showMoreNavLink && (
        <Link onClick={handleClick} sx={{ root: { cursor: 'pointer' } }} underline="hover">
          <MoreVert />
        </Link>
      )}
      <Menu
        id="more-item-sublist"
        className="more-item-sublist"
        open={Boolean(menuAnchor)}
        anchorEl={menuAnchor}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        variant="menu"
        keepMounted
        PaperProps={{
          elevation: 0,
        }}
        sx={{
          typography: 'body2',
          a: {
            padding: '5px 15px',
          },
          filter: 'drop-shadow(0px 2px 10px rgba(0,0,0,0.15))',
          '& .MuiPaper-root': {
            minWidth: '150px',
            overflow: 'visible',
            marginTop: '-20px',
            // visibility: Boolean(menuAnchor) ? 'visible' : 'hidden',
          },
          '& .MuiPaper-root:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: '22px',
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        }}
      />
    </>
  )
}
